import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a53536a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-content-week" }
const _hoisted_2 = { class: "booking-info-week" }
const _hoisted_3 = { class: "booking-id-week" }
const _hoisted_4 = { class: "customer-name-week" }
const _hoisted_5 = {
  key: 0,
  class: "customer-name-kana-week"
}
const _hoisted_6 = { class: "event-time-week" }

import { withDefaults, computed, ref } from "vue";
import { get, onClickOutside } from "@vueuse/core";
import { BookingStatusColorClass } from "@/clinic/typings/enums/booking";
import { Dictionary, EventImpl } from "@fullcalendar/core/internal";
import BookingMenuItem from "./menu.vue";
import moment from "moment";
import TimeUtils from "@/clinic/utils/time-utils";

type IEventType = {
  event: EventImpl;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as { event: EventImpl };



const extendedProps = computed((): Dictionary => props.event.extendedProps);

// 週表示ではbookings配列の最初の予約データを使用
const bookingData = computed(() => {
  const props = get(extendedProps);
  if (props.bookings && props.bookings.length > 0) {
    return props.bookings[0]; // 最初の予約データを取得
  }
  return {};
});

const { status } = get(extendedProps);

// bookings配列から実際の予約データを取得
const booking = get(bookingData);
const customerName = booking.customer_name || "";
const customerNameKana = booking.customer_name_kana || "";
const customerStatus = booking.customer_status || "";
const reservationId = booking.id || props.event.id;

const menuList = ref<HTMLElement | null>(null);

const isLastItem = (event: any): boolean => {
  let current_date = new Date(event.startStr);
  let start_date = props.event._context.calendarApi.view.currentStart;
  const final_date = new Date();
  final_date.setDate(start_date.getDate() + 6);
  const semi_final_date = new Date();
  semi_final_date.setDate(start_date.getDate() + 5);
  if (final_date.getDay() == current_date.getDay() || semi_final_date.getDay() == current_date.getDay()) {
    return true;
  }
  return false;
};

/**
 * 予約IDを6桁のゼロパディング形式でフォーマット
 */
const formattedBookingId = computed((): string => {
  const id = reservationId || props.event.id;
  return String(id).padStart(6, "0");
});

/**
 * 予約の開始時間をフォーマット
 */
const formattedStartTime = computed((): string => {
  const booking = get(bookingData);
  if (booking.start_time) {
    return moment(TimeUtils.toLocalTime(booking.start_time)).format("HH:mm");
  }
  return "";
});

/**
 * 予約の終了時間をフォーマット
 */
const formattedEndTime = computed((): string => {
  const booking = get(bookingData);
  if (booking.end_time) {
    return moment(TimeUtils.toLocalTime(booking.end_time)).format("HH:mm");
  }
  return "";
});

/**
 * イベントカードのCSSクラス名を取得
 * 顧客ステータスと予約ステータスに基づいてカラークラスを決定
 */
const eventColorClass = computed((): string => {
  // 予約（will_come）の場合、顧客ステータスと組み合わせる
  if (status === "will_come" && customerStatus) {
    const key = `will_come_${customerStatus}` as keyof typeof BookingStatusColorClass;
    const colorClass = BookingStatusColorClass[key];
    if (colorClass) {
      return colorClass;
    }
    return "bg-booking-existed";
  }

  // その他のステータス
  if (status) {
    const colorClass = BookingStatusColorClass[status as keyof typeof BookingStatusColorClass];
    if (colorClass) {
      return colorClass;
    }
  }

  return "bg-booking-existed";
});

/**
 * テキストカラークラスを取得
 * キャンセル系は白、それ以外は黒
 */
const textColorClass = computed((): string => {
  if (status === "cancel" || status === "cancel_not_notice") {
    return "text-white";
  }
  return "text-black";
});

const addZIndexForClickedMenu = () => {
  let menus = get(menuList)?.getMenu?.closest("tr").querySelectorAll(".fc-timeline-event-harness");
  menus.forEach(element => element.classList.remove("z-5"));
  menus.forEach(element => element.classList.add("z-1"));
  get(menuList)?.getMenu?.closest(".fc-timeline-event-harness").classList.remove("z-1");
  get(menuList)?.getMenu?.closest(".fc-timeline-event-harness").classList.add("z-5");
};

const addZIndexForStaffRow = () => {
  let weekBookings = get(menuList)?.getMenu?.closest("tbody").querySelectorAll("tr");
  weekBookings.forEach(element => element.classList.remove("z-5"));
  weekBookings.forEach(element => element.classList.add("z-1", "relative"));

  get(menuList)?.getMenu?.closest("tr").classList.remove("z-1");
  get(menuList)?.getMenu?.closest("tr").classList.add("z-5");
};

const onClick = () => {
  if (!get(menuList)) return;

  addZIndexForClickedMenu();
  addZIndexForStaffRow();

  get(menuList)?.getMenu?.classList.remove("hidden");
};

onClickOutside(menuList, () => get(menuList)?.hideMenu());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["booking-event-card-week", [_unref(eventColorClass), _unref(textColorClass)]]),
      onClick: onClick
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formattedBookingId)), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(customerName) || "顧客なし"), 1),
          (_unref(customerNameKana))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "( " + _toDisplayString(_unref(customerNameKana)) + " )", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formattedStartTime)) + " 〜 " + _toDisplayString(_unref(formattedEndTime)), 1)
      ])
    ], 2),
    _createVNode(BookingMenuItem, {
      ref_key: "menuList",
      ref: menuList,
      event: __props.event,
      isLastItem: isLastItem(__props.event)
    }, null, 8, ["event", "isLastItem"])
  ], 64))
}
}

})